export const version = '2.70.0';
//# sourceMappingURL=version.js.map